import { forwardRef, TextareaHTMLAttributes } from 'react';
import styled from 'styled-components';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  hasError?: boolean;
}

const StyledTextarea = styled.textarea<{ $hasError?: boolean }>`
  width: 100%;
  min-height: 96px;
  padding: 10px 12px;
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.colors.bgSurface};
  color: ${({ theme }) => theme.colors.textPrimary};
  border: 1px solid
    ${({ theme, $hasError }) =>
      $hasError ? theme.colors.danger : theme.colors.border};
  font-family: ${({ theme }) => theme.font.secondary};
  font-size: 14px;
  line-height: 1.4;
  resize: vertical;
  transition: all ${({ theme }) => theme.transitions.base};

  &::placeholder {
    color: ${({ theme }) => theme.colors.textMuted};
  }

  &:hover:not(:disabled) {
    border-color: ${({ theme, $hasError }) =>
      $hasError ? theme.colors.danger : theme.colors.borderStrong};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme, $hasError }) =>
      $hasError ? theme.colors.danger : theme.colors.brandPrimary};
    box-shadow: 0 0 0 3px
      ${({ theme, $hasError }) =>
        $hasError ? theme.colors.dangerBg : theme.colors.bgMuted};
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.bgMuted};
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ hasError, ...rest }, ref) => (
    <StyledTextarea ref={ref} $hasError={hasError} {...rest} />
  ),
);

Textarea.displayName = 'Textarea';
